import { render, staticRenderFns } from "./SectorAndCategroy.vue?vue&type=template&id=04395d86&scoped=true&"
import script from "./SectorAndCategroy.vue?vue&type=script&lang=ts&"
export * from "./SectorAndCategroy.vue?vue&type=script&lang=ts&"
import style0 from "./SectorAndCategroy.vue?vue&type=style&index=0&id=04395d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04395d86",
  null
  
)

export default component.exports